import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './country-selector-online-banking.component.scss';
var CountrySelectorOnlineBanking = /** @class */ (function (_super) {
    tslib_1.__extends(CountrySelectorOnlineBanking, _super);
    function CountrySelectorOnlineBanking(element) {
        return _super.call(this, element) || this;
    }
    CountrySelectorOnlineBanking.prototype.init = function () {
        var _this = this;
        this.countries = [];
        this.input = this.element.querySelector('.country-selector-online-banking__search-input');
        if (this.element.querySelector('.country-selector-online-banking__section-country')) {
            var items = Array.from(this.element.querySelectorAll('.country-selector-online-banking__section-country'));
            items.forEach(function (item) {
                var dataCountry = item.getAttribute('data-country');
                var dataSection = item.getAttribute('data-section');
                var element = item;
                _this.countries.push({
                    country: dataCountry,
                    section: dataSection,
                    element: element
                });
            });
        }
    };
    CountrySelectorOnlineBanking.prototype.bindEvents = function () {
        var _this = this;
        if (this.input) {
            this.input.addEventListener('keyup', function (event) {
                var element = event.target;
                var searchParam = element.value.toLowerCase();
                if (searchParam.length > 0) {
                    var countrySections = Array.from(_this.element.querySelectorAll('.country-selector-online-banking__section'));
                    countrySections.map(function (section) {
                        section.classList.add('d-none');
                    });
                    var countrySectionCountries = Array.from(_this.element.querySelectorAll('.country-selector-online-banking__section-country'));
                    countrySectionCountries.map(function (country) {
                        country.classList.add('d-none');
                    });
                    _this.countries.filter(function (item, index) {
                        return item.country.toLowerCase().indexOf(searchParam) > -1;
                    }).forEach(function (country) {
                        country.element.classList.remove('d-none');
                        var countrySections = Array.from(_this.element.querySelectorAll(".country-selector-online-banking__section[data-section='" + country.section + "']"));
                        countrySections.map(function (section) {
                            section.classList.remove('d-none');
                        });
                    });
                }
                else {
                    _this.countries.forEach(function (country) {
                        country.element.classList.remove('d-none');
                        var countrySections = Array.from(_this.element.querySelectorAll('.country-selector-online-banking__section'));
                        countrySections.map(function (section) {
                            section.classList.remove('d-none');
                        });
                    });
                }
            });
        }
    };
    return CountrySelectorOnlineBanking;
}(Base));
export { CountrySelectorOnlineBanking };



//////////////////
// WEBPACK FOOTER
// ./components/country-selector-online-banking/country-selector-online-banking.component.ts
// module id = 725
// module chunks = 0